import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";
import { useI18n } from "../i18n/LanguageContext";

const BackToTop = () => {
    const { t } = useI18n();
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const onScroll = () => setVisible(window.scrollY > 500);
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    if (!visible) return null;

    return (
        <button
            data-testid="back-to-top"
            aria-label={t.misc.back_to_top}
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="fixed bottom-6 left-6 z-50 w-11 h-11 md:w-12 md:h-12 bg-brand-navy hover:bg-brand-gold text-white flex items-center justify-center transition-colors shadow-[0_10px_30px_rgba(11,27,61,0.35)]"
        >
            <ArrowUp className="w-5 h-5" />
        </button>
    );
};

export default BackToTop;
